import React from 'react';

const HealthCheck = () => <h1> THIS IS THE HEALTH CHECK PAGE! </h1>;

export const healthCheckRoutes = { path: 'health', element: <HealthCheck /> };
